import { render, staticRenderFns } from "./TheSpinner.vue?vue&type=template&id=495c3c1a&scoped=true"
import script from "./TheSpinner.vue?vue&type=script&lang=js"
export * from "./TheSpinner.vue?vue&type=script&lang=js"
import style0 from "./TheSpinner.vue?vue&type=style&index=0&id=495c3c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495c3c1a",
  null
  
)

export default component.exports